import { i18n } from '@/plugins/i18n';
import { merchantType, merchantTypeStr } from '@/constants/merchantType';
import { stakeholderStatusStr, stakeholderVariant } from '@/constants/stakeholderStatus';
import {
    relatedMerchantType,
    relatedMerchantTypeStr,
    relatedMerchantTypeVariant
} from '@/constants/related_merchant_type';

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'wallet_hashid',
        title: i18n.t('label.wallet_hashid'),
        sortable: false,
        textAlign: 'center',
        width: 60,
    },
    {
        field: 'fullname',
        title: i18n.t('label.shareholder_name'),
        sortable: false,
        textAlign: 'center',
        width: 150
    },
    {
        field: 'user_fullname',
        title: i18n.t('label.User_full_name'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'phone',
        title: i18n.t('label.phone'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'iban',
        title: i18n.t('label.iban'),
        sortable: false,
        textAlign: 'center',
        width: 150
    },
    {
        field: 'level',
        title: i18n.t('label.level'),
        sortable: false,
        textAlign: 'center',
        width: 50
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    }
]
